import api from "./api";

class UserService {
    list() {
        return api.get("/api/users/");
    }

    create(data) {
        return api.post("/api/users/create/", data);
    }

    update(id, data) {
        return api.patch(`/api/users/${id}/`, data);
    }

    delete(id) {
        return api.delete(`/api/users/${id}/delete/`);
    }

    toggleActive(id) {
        return api.post(`/api/users/${id}/toggle-active/`);
    }

    listGroups() {
        return api.get("/api/users/groups/");
    }
}

export default new UserService();
